import { useSaveActions } from "../../common"
import { TableName } from "../../../tables"
import { PurchaseOrder } from "../state/types"

export const usePurchaseActions = () => {
    const saveActions = useSaveActions()

    const savePurchase = (purchase: PurchaseOrder) => {
        const { save } = saveActions()
        return save(TableName.PURCHASE_ORDERS, purchase) as Promise<PurchaseOrder>
    }

    return {
        savePurchase
    }
}
